import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import UploadFile from "../UploadFile/UploadFile";
import Checkbox from "../CheckboxNew";
import {
  getAgeDisplay,
  getOnPhonesDisplay,
  getInPoolDisplay,
  getYearsAtSummitDisplay,
} from "../../utils/teamMemberDerivedFields";
import { fileTypes } from "../../consts/consts";

const SUMMIT_AGENT_TITLES = [
  'Associate',
  'Senior Associate',
  'Vice President',
  'First Vice President',
  'Senior Vice President',
  'Executive Vice President',
  'Vice Chairman',
  'Partner'
];

const TeamMemberInfo = ({
  data,
  offices = [],
  handleChangeInput,
  handleChangeDropdown,
  handleChangeFile,
  viewMode,
  deleted,
  addNewItem,
  isExists,
  // Role, Termination Date and Email are account settings (team.accounts):
  // a level that only views them sees them read-only here too.
  accountFieldsViewOnly = false,
}) => {
  const isSummitAgent = data.IS_AGENT === 'a' || data.IS_AGENT === 'y';
  const accountFieldsViewMode = viewMode || accountFieldsViewOnly;
  // Keep a legacy/custom title selectable so it still displays after the
  // field became a dropdown.
  const titleOptions = data.TITLE && SUMMIT_AGENT_TITLES.indexOf(data.TITLE) === -1
    ? [data.TITLE, ...SUMMIT_AGENT_TITLES]
    : SUMMIT_AGENT_TITLES;

  return (
    <div className="Team-member-info">
      {(isExists) && <p className="errorText"> Given Team Member Details Already Exists</p>}
      <div className="Team-member-info_checkbox-row">
        <Checkbox
            text="summitre.io"
            type={viewMode ? "uncheckable" : "checkable"}
            isSelected={data.VISIBLE_ON_WEBSITE === 'Y' || data.VISIBLE_ON_WEBSITE === 'y'}
            handleClick={() => handleChangeInput('VISIBLE_ON_WEBSITE', (data.VISIBLE_ON_WEBSITE === 'Y' || data.VISIBLE_ON_WEBSITE === 'y') ? '' : 'Y')}
            name="VISIBLE_ON_WEBSITE"
        />
        <Checkbox
            text="peakcapital.io"
            type={viewMode ? "uncheckable" : "checkable"}
            isSelected={data.SHOW_IN_PEAK === 'Y' || data.SHOW_IN_PEAK === 'y'}
            handleClick={() => handleChangeInput('SHOW_IN_PEAK', (data.SHOW_IN_PEAK === 'Y' || data.SHOW_IN_PEAK === 'y') ? '' : 'Y')}
            name="SHOW_IN_PEAK"
        />
      </div>
      <div className="Team-member-info_column">
        <Dropdown
            className="Team-member-info_column_item"
            data={data}
            optionKey='code'
            optionLabelKey='name'
            optionsType="roles"
            value={data.IS_AGENT}
            valueKey="IS_AGENT"
            label="Role"
            handleParentChange={handleChangeDropdown}
            viewMode={accountFieldsViewMode}
            deleted={deleted}
        />              
        
        <UploadFile
            className="Team-member-info_column_item"
            data={data}
            name="PHOTO"
            label="Profile Picture"
            link={data.PHOTO}
            fileType={fileTypes.Photo}
            folder="team/picture"
            handleChange={handleChangeFile}
            viewMode={viewMode}
            deleted={deleted}
        />

        <Input className="Team-member-info_column_item"
            required
            valueType='text'
            name='FIRST_NAME'
            label='First Name'
            value={data.FIRST_NAME}                
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input className="Team-member-info_column_item"
            required
            valueType='text'
            name='LAST_NAME'
            label='Last Name'
            value={data.LAST_NAME}               
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Dropdown
            className="Team-member-info_column_item"
            data={data}
            options={offices}
            optionKey="ARCIMEDES_ROW_ID"
            optionLabelKey="OFFICE_LABEL"
            value={data.OFFICE_ID}
            valueKey="OFFICE_ID"
            label="Office"
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted}
            placeholder="Select office"
        />
        {isSummitAgent ? (
          <Dropdown
              className="Team-member-info_column_item"
              data={data}
              options={titleOptions}
              value={data.TITLE}
              valueKey="TITLE"
              label="Title"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
              placeholder="Select title"
          />
        ) : (
          <Input className="Team-member-info_column_item"
              valueType='text'
              name='TITLE'
              label='Title'
              value={data.TITLE}
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
          />
        )}
        <Input className="Team-member-info_column_item"
            valueType='text'
            name='LINKEDIN'
            label='LinkedIn URL'
            value={data.LINKEDIN}               
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="STARTING_DATE"
            label="Start Date"
            value={data.STARTING_DATE}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />

        <Input
            className="Team-member-info_column_item"
            disabled
            valueType="text"
            name="YRS_AT_STRIVE"
            label="Years at Summit"
            value={getYearsAtSummitDisplay(data)}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />        
        <Input
            className="Team-member-info_column_item"
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="BIRTH_DATE"
            label="Birth Date"
            value={data.BIRTH_DATE}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            disabled
            valueType="text"
            name="AGE"
            label="Age"
            value={getAgeDisplay(data)}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        </div>
        <div className="Team-member-info_column"> 
        {/* On Phones / In Pool / 1st Listing / Closing are Summit Agent only */}
        {isSummitAgent && <div>
        <Input
            className="Team-member-info_column_item"
            disabled
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="ON_PHONES"
            label="On Phones"
            value={getOnPhonesDisplay(data)}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />        
        <Input
            className="Team-member-info_column_item"
            disabled
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="IN_POOL"
            label="In Pool"
            value={getInPoolDisplay(data)}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            disabled
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="FIRST_LISTING"
            label="1st Listing"
            value={data.FIRST_LISTING}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />           
        <Input
            className="Team-member-info_column_item"
            disabled
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="FIRST_CLOSING"
            label="1st Closing"
            value={data.FIRST_CLOSING}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />     
        </div>}
        <Input
            className="Team-member-info_column_item"
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="TERMINATION_DATE"
            label="Termination Date"
            value={data.TERMINATION_DATE}            
            handleParentChange={handleChangeInput}
            viewMode={accountFieldsViewMode}
            deleted={deleted}
        />
        </div>
        <div className="Team-member-info_column">
        <Input
          className="Team-member-info_column_item"
          valueType="email"
          name="EMAIL"
          label="Email"
          value={data.EMAIL}
          handleParentChange={handleChangeInput}
          viewMode={accountFieldsViewMode}
          deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            valueType="phone"
            name="PHONE"
            label="Work Phone"
            value={data.PHONE}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />    
        <Input
            className="Team-member-info_column_item"
            valueType="phone"
            name="CELL_PHONE"
            label="Cell Phone"
            value={data.CELL_PHONE}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        /> 
        <Input
            className="Team-member-info_column_item"
            valueType="text"
            name="ADDRESS"
            label="Address"
            value={data.ADDRESS}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            valueType="text"
            name="CITY"
            label="City"
            value={data.CITY}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
       
        <Dropdown
            className="Team-member-info_column_item"
            data={data}
            optionsType="states"
            optionKey="abbr"
            optionLabelKey="name"
            value={data.STATE}
            valueKey="STATE"
            label="State"            
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            valueType="number"
            maxLength={5}
            name="ZIP"
            label="Zip"
            value={data.ZIP}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            valueType="number"
            name="ORDER"
            label="Display Order"
            value={data.ORDER}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            inputType="textarea"
            valueType="text"
            name="BIO"
            label="Bio"
            value={data.BIO}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />


      </div>
    </div>
  );
};

export default TeamMemberInfo;
